import { Injectable } from '@angular/core';
import { HttpServiceBundle } from './base/http-service-bundle.service';
import {
    UriBuilderParams,
    BaseHttpService,
    Query,
    Create,
    Delete,
    Update
} from './base/base-http.service';
import { Payment } from '@app/shared/models/payment';
import { BackendUriUnits } from './base/backend-uri-units';
import { Case } from '@app/shared/models/case';
import { DrQueryParams, OpData } from './base/base-service-with-bundle.service';
import { Observable } from 'rxjs';
import { BaseWithIdList } from '@app/shared/models/list';
import { map } from 'rxjs/operators';

export class CasePaymentUriBuilderParams extends UriBuilderParams<Payment> {

    private readonly _case: string;

    get case() {
        return this._case;
    }

    constructor(caseX?: Case | string, payment?: Payment | string) {
        super(payment);
        this._case = this.getParamId(caseX);
    }

    public buildUri(): string  {
        return `/${BackendUriUnits.CASES}/${this.case}${this.simpleUriBuild(BackendUriUnits.PAYMENTS)}`;
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentService extends BaseHttpService<Payment, CasePaymentUriBuilderParams>
                            implements Query<Payment, CasePaymentUriBuilderParams>,
                                       Create<Payment, CasePaymentUriBuilderParams>,
                                       Update<Payment, CasePaymentUriBuilderParams>,
                                       Delete<Payment, CasePaymentUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(Payment, httpServiceBundle);
    }

    public query(uriParams: CasePaymentUriBuilderParams): Observable<BaseWithIdList<Payment>> {
        return this.queryBase(uriParams)
                   .pipe(map(result => BaseWithIdList.upgradeFromBaseList(result)));
    }

    public create(uriParams: CasePaymentUriBuilderParams, toCreate: Payment): Observable<Payment> {
        return this.createBase(uriParams, toCreate);
    }

    public delete(uriParams: CasePaymentUriBuilderParams, params?: DrQueryParams): Observable<boolean> {
        return this.deleteBase(uriParams, params);
    }

    public update(uriParams: CasePaymentUriBuilderParams, toUpdate: Payment, params?: DrQueryParams): Observable<Payment> {
        return this.updateBase(uriParams, toUpdate, params);
    }

}
